import { Auth } from 'aws-amplify';
import axios from 'axios';
import { GET_USER_DETAILS } from '../types';
import { MAIN_USER_API_URL } from '../API';

export const getAdditionalUserInfo = () => async (dispatch) => {
  const user = await Auth.currentAuthenticatedUser();
  const token = user.signInUserSession.idToken.jwtToken;
  const email = user.attributes.email;

  try {
    const res = await axios.get(MAIN_USER_API_URL, {
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer '.concat(token),
      },
      params: {
        email,
      },
    });
    if (res) {
      dispatch({
        type: GET_USER_DETAILS,
        payload: res.data,
      });
    }
  } catch (err) {
    if (err.response) {
      // The client was given an error response (5xx, 4xx)
      console.log(err.response.data);
      console.log(err.response.status);
      console.log(err.response.headers);
    } else if (err.request) {
      console.log(err.request);
      // The client never received a response, and the request was never left
    } else {
      console.log('Error', err.message);
    }
  }
};
